/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailStatusResponse
 */
export interface EmailStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof EmailStatusResponse
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof EmailStatusResponse
     */
    verified: boolean;
}

/**
 * Check if a given object implements the EmailStatusResponse interface.
 */
export function instanceOfEmailStatusResponse(value: object): value is EmailStatusResponse {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('verified' in value) || value['verified'] === undefined) return false;
    return true;
}

export function EmailStatusResponseFromJSON(json: any): EmailStatusResponse {
    return EmailStatusResponseFromJSONTyped(json, false);
}

export function EmailStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'verified': json['verified'],
    };
}

  export function EmailStatusResponseToJSON(json: any): EmailStatusResponse {
      return EmailStatusResponseToJSONTyped(json, false);
  }

  export function EmailStatusResponseToJSONTyped(value?: EmailStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'verified': value['verified'],
    };
}

